export default function About() {
  const features = [
    {
      icon: 'ri-user-star-line',
      title: 'Entraîneurs Experts',
      description: 'Équipe d\'entraîneurs diplômés et passionnés avec une expertise reconnue'
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Domaine d\'Exception',
      description: 'Orelle, porte d\'entrée des Trois Vallées'
    },
    {
      icon: 'ri-group-line',
      title: 'Entraînements Personnalisés',
      description: 'Petits groupes adaptés à votre niveau'
    },
    {
      icon: 'ri-medal-line',
      title: 'Préparation Compétition',
      description: 'Programme complet pour vos objectifs'
    }
  ];

  return (
    <section id="about" className="py-24 bg-black text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <h3 className="text-5xl md:text-6xl font-black mb-8 tracking-tight uppercase">
              Pourquoi Nous Rejoindre ?
            </h3>
            <div className="w-24 h-1 bg-white mb-8"></div>
            <p className="text-lg text-gray-300 mb-8 leading-relaxed font-light">
              Situé au cœur des Alpes françaises, Orelle Freeski est votre club de ski privilégié pour découvrir et maîtriser toutes les facettes du ski moderne. Que vous souhaitiez apprendre les bases de la sécurité en montagne, explorer les pentes vierges en freeride, vous perfectionner en freestyle ou vous préparer physiquement pour des compétitions, notre équipe d'entraîneurs passionnés et diplômés vous accompagne avec professionnalisme et bienveillance.
            </p>
            <p className="text-lg text-gray-300 mb-12 leading-relaxed font-light">
              Nous croyons que le ski est bien plus qu'un sport : c'est une passion, un art de vivre et une communion avec la montagne. Notre approche pédagogique allie technique, sécurité et plaisir pour vous permettre de progresser rapidement tout en profitant pleinement de chaque instant sur les skis.
            </p>

            <div className="grid sm:grid-cols-2 gap-6">
              {features.map((feature, index) => (
                <div key={index} className="border-2 border-white p-6 hover:bg-white hover:text-black transition-all duration-300 cursor-pointer">
                  <div className="w-12 h-12 flex items-center justify-center bg-white text-black mb-4">
                    <i className={`${feature.icon} text-2xl`}></i>
                  </div>
                  <h5 className="font-bold mb-2 uppercase tracking-wide text-sm">{feature.title}</h5>
                  <p className="text-sm opacity-80 font-light">{feature.description}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <div className="border-4 border-white overflow-hidden">
              <img 
                src="https://static.readdy.ai/image/71745ccb8c79f3954a4900c745433851/aa6b1d6dfe399c7ec059b91c386d320b.png"
                alt="Équipe Orelle Freeski"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-8 -right-8 bg-white text-black p-8 border-4 border-black max-w-xs">
              <div className="text-6xl font-black mb-2">15+</div>
              <div className="text-lg font-bold uppercase tracking-wide">Années d'expérience</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}